import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { formatDateForView } from '../../utils/Date';

const Date = styled.div`
  color: ${props => props.theme.colors.darkerGrey};
  margin-bottom: 0.5em;
`;

const DateRange = ({ startDate, endDate, className }) => {
  if (endDate) {
    return (
      <Date className={className}>{`${formatDateForView(startDate)} - ${formatDateForView(endDate)}`}</Date>
    );
  }
  return (<Date className={className}>{`${formatDateForView(startDate)} - Present`}</Date>);
};

DateRange.propTypes = {
  startDate: PropTypes.string.isRequired,
  endDate: PropTypes.string,
  className: PropTypes.string,
};

DateRange.defaultProps = {
  endDate: null,
  className: '',
};

export default DateRange;
